
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcCardListButton as ObcCardListButtonElement} from '@oicl/openbridge-webcomponents/dist/components/card-list-button/card-list-button.js';
 
 
 

 
 export const ObcCardListButton = createComponent({
   react: React,
   tagName: 'obc-card-list-button',
   elementClass: ObcCardListButtonElement,
   events: {
     
   }
  });
 
 